const DEFAULT_DEV_API_BASE = 'http://localhost:50000';
const DEFAULT_PROD_API_BASE = 'https://api.xup.digital';

function normalizeBaseUrl(value: string): string {
  // Remove trailing slashes so `${API_BASE}/path` is stable.
  return value.replace(/\/+$/, '');
}

function resolveApiBase(): string {
  const raw = (process.env.REACT_APP_API_BASE ?? '').trim();
  if (raw) return normalizeBaseUrl(raw);

  // No explicit env var. Auto-detect based on the current hostname so a single
  // build can work for both local and online environments.
  if (typeof window !== 'undefined') {
    const host = (window.location.hostname ?? '').toLowerCase();
    if (host === 'localhost' || host === '127.0.0.1') {
      return DEFAULT_DEV_API_BASE;
    }
    // When served on the xup.digital domain (or any non-localhost host), default
    // to the public API domain.
    return DEFAULT_PROD_API_BASE;
  }

  if (process.env.NODE_ENV === 'production') {
    // In production a missing API base is almost always a deployment misconfig.
    // Fall back to the public API domain, and make it visible in the console.
    // eslint-disable-next-line no-console
    console.warn(
      '[config] REACT_APP_API_BASE is not set; falling back to ' + DEFAULT_PROD_API_BASE
    );
    return DEFAULT_PROD_API_BASE;
  }

  return DEFAULT_DEV_API_BASE;
}

export const API_BASE = resolveApiBase();
